import GuestGuard from "../components/GuestGuard";
import Dashboard from "./Dashboard";

export default function GuestDashboard() {
  return (
    <GuestGuard>
      <Dashboard />
    </GuestGuard>
  );
}

